module.exports = __webpack_public_path__ + "static/media/400111_02.fa8b14b9.png";